import React, { useRef, useEffect } from 'react';

const Input = ({ prefix, postfix, ...rest }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    // Set prefix and postfix attributes on the custom element
    if (inputRef.current) {
      if (prefix !== undefined && prefix !== null) {
        inputRef.current.setAttribute('prefix', prefix);
      }
      if (postfix !== undefined && postfix !== null) {
        inputRef.current.setAttribute('postfix', postfix);
      }
    }
  }, [prefix, postfix]);

  return (
    <nsemble-input
      ref={inputRef}
      {...rest}
    />
  );
};

export default Input;
